import { errHandler } from "utils/common";
import api from "utils/api";

export default class UjiSilangService {
  getAll = (opt = { searchBy: "", searchValue: "", page: 1, limit: 10 }) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/uji-silang`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  add = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .post("/api/uji-silang?device=Online", payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  update = (payload, id) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/api/uji-silang/${id}?device=Online`, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  remove = (id) => {
    return new Promise((resolve, reject) => {
      api
        .delete(`/api/uji-silang/${id}?device=Online`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  petugasMikroskopis = (
    opt = { searchBy: "", searchValue: "", page: 1, limit: 10 }
  ) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/uji-silang-petugas-mikroskopis`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  petugasCrosschecker = (
    opt = { searchBy: "", searchValue: "", page: 1, limit: 10 }
  ) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/uji-silang-petugas-crosschecker`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  slideGetAll = (
    opt = { searchBy: "", searchValue: "", page: 1, limit: 10 }
  ) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/uji-silang-slide`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  slideUpdate = (payload, id) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/api/uji-silang-slide/${id}?device=Online`, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  slideBulk = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/api/uji-silang-slide-bulk?device=Online`, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  checkSlideCodeDuplicate = (params) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/uji-silang-slide-check-duplicate`, { params })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
